module.exports = __webpack_public_path__ + "9288498aab1344c8d9e1e37d58f5fd71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-placeholder-640.png
// module id = 208
// module chunks = 0